import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { VirtualConnectionTableLineageCountsFragmentGql } from './VirtualConnectionTableLineageCountsFragmentGql';

export const VirtualConnectionTableLineageCountsQueryGql: DocumentNode = gql`
query VirtualConnectionTableLineageCountsQuery($vizportalUrlId: String!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    ...VirtualConnectionTableLineageCountsFragment
  }
}
${VirtualConnectionTableLineageCountsFragmentGql}
`;
